// Remove final Z from date ISO string
export const trimZ = (date: string): string => (date.endsWith('Z') ? date.slice(0, -1) : date);
